import React from 'react';
import { Download, Upload, Clock, Wifi } from 'lucide-react';

const ResultsGrid = ({ results, currentPhase }) => {
  if (currentPhase !== 'complete' && results.downloadSpeed === 0) return null;

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
      <div className="bg-white dark:bg-gray-800/50 rounded-2xl p-4 text-center border border-[#1E9B4C]/20 dark:border-green-500/20">
        <Download className="w-6 h-6 text-[#1E9B4C] dark:text-green-400 mx-auto mb-2" />
        <div className="text-xl font-bold text-[#1E9B4C] dark:text-green-400">{results.downloadSpeed.toFixed(1)}</div>
        <div className="text-xs text-gray-600 dark:text-gray-400">Mbps Down</div>
      </div>
      <div className="bg-white dark:bg-gray-800/50 rounded-2xl p-4 text-center border border-[#1E9B4C]/20 dark:border-green-500/20">
        <Upload className="w-6 h-6 text-[#1E9B4C] dark:text-green-400 mx-auto mb-2" />
        <div className="text-xl font-bold text-[#1E9B4C] dark:text-green-400">{results.uploadSpeed.toFixed(1)}</div>
        <div className="text-xs text-gray-600 dark:text-gray-400">Mbps Up</div>
      </div>
      <div className="bg-white dark:bg-gray-800/50 rounded-2xl p-4 text-center border border-[#1E9B4C]/20 dark:border-green-500/20">
        <Clock className="w-6 h-6 text-[#1E9B4C] dark:text-green-400 mx-auto mb-2" />
        <div className="text-xl font-bold text-[#1E9B4C] dark:text-green-400">{results.ping.toFixed(0)}</div>
        <div className="text-xs text-gray-600 dark:text-gray-400">ms Ping</div>
      </div>
      <div className="bg-white dark:bg-gray-800/50 rounded-2xl p-4 text-center border border-[#1E9B4C]/20 dark:border-green-500/20">
        <Wifi className="w-6 h-6 text-[#1E9B4C] dark:text-green-400 mx-auto mb-2" />
        <div className="text-xl font-bold text-[#1E9B4C] dark:text-green-400">{results.jitter.toFixed(0)}</div>
        <div className="text-xs text-gray-600 dark:text-gray-400">ms Jitter</div>
      </div>
    </div>
  );
};

export default ResultsGrid;